/**
 * SeeFilesButton — small external-link button that opens the matching Google Drive
 * folder (admin/accounting docs, fund reports) for a card/entity in a new tab.
 *
 * Renders nothing if `url` is falsy, so callers can pass getDriveFolderUrl(...) directly.
 *
 * Two variants:
 *   default          → text pill for popup headers ("See Files ↗")
 *   variant="icon"   → compact folder glyph for the dashboard card
 */
import React from 'react';
import './SeeFilesButton.css';

function SeeFilesButton({ url, variant = 'default', title = 'Open the Drive folder' }) {
  if (!url) return null;

  const onClick = (e) => {
    // Don't let the click bubble to the card/popup (which would open/close it).
    e.stopPropagation();
  };

  if (variant === 'icon') {
    return (
      <a
        className="see-files-icon"
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        onClick={onClick}
        title={title}
        aria-label="See files"
      >
        🗂
      </a>
    );
  }

  return (
    <a
      className="see-files-btn"
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onClick}
      title={title}
    >
      See Files ↗
    </a>
  );
}

export default SeeFilesButton;
